function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useCallback } from 'react';
import { RcCarousel } from '../../hooks/carousel';
import { CarouselWrapper } from './CarouselWrapper';
var Carousel = React.forwardRef(function (props, ref) {
  var _props$delay = props.delay,
      delay = _props$delay === void 0 ? 400 : _props$delay,
      _props$speed = props.speed,
      speed = _props$speed === void 0 ? 3000 : _props$speed,
      _props$effect = props.effect,
      effect = _props$effect === void 0 ? 'slide' : _props$effect,
      _props$autoplay = props.autoplay,
      autoplay = _props$autoplay === void 0 ? false : _props$autoplay,
      _props$paginationType = props.paginationType,
      paginationType = _props$paginationType === void 0 ? 'progress' : _props$paginationType,
      _props$paginationColo = props.paginationColor,
      paginationColor = _props$paginationColo === void 0 ? '#E4E9ED' : _props$paginationColo,
      _props$paginationPosi = props.paginationPosition,
      paginationPosition = _props$paginationPosi === void 0 ? 'left' : _props$paginationPosi,
      _props$paginationActi = props.paginationActiveColor,
      paginationActiveColor = _props$paginationActi === void 0 ? '#FFF' : _props$paginationActi,
      _props$arrowSize = props.arrowSize,
      arrowSize = _props$arrowSize === void 0 ? 32 : _props$arrowSize,
      _props$arrowTheme = props.arrowTheme,
      arrowTheme = _props$arrowTheme === void 0 ? 'filled' : _props$arrowTheme,
      _props$arrowFillColor = props.arrowFillColor,
      arrowFillColor = _props$arrowFillColor === void 0 ? '#999' : _props$arrowFillColor,
      onActiveChange = props.onActiveChange,
      children = props.children,
      extra = _objectWithoutProperties(props, ["delay", "speed", "effect", "autoplay", "paginationType", "paginationColor", "paginationPosition", "paginationActiveColor", "arrowSize", "arrowTheme", "arrowFillColor", "onActiveChange", "children"]);

  var compRef = useRef(null);
  var goTo = useCallback(function (nextIndex) {
    var _a;

    (_a = compRef.current) === null || _a === void 0 ? void 0 : _a.goTo(nextIndex);
  }, []);
  var prev = useCallback(function () {
    var _a;

    (_a = compRef.current) === null || _a === void 0 ? void 0 : _a.prev();
  }, []);
  var next = useCallback(function () {
    var _a;

    (_a = compRef.current) === null || _a === void 0 ? void 0 : _a.next();
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      goTo: goTo,
      prev: prev,
      next: next
    };
  });
  return React.createElement(RcCarousel, {
    delay: delay,
    speed: speed,
    effect: effect,
    autoplay: autoplay,
    arrowSize: arrowSize,
    arrowTheme: arrowTheme,
    arrowFillColor: arrowFillColor,
    paginationType: paginationType,
    paginationColor: paginationColor,
    paginationPosition: paginationPosition,
    paginationActiveColor: paginationActiveColor
  }, React.createElement(CarouselWrapper, Object.assign({}, extra, {
    ref: compRef,
    onActiveChange: onActiveChange
  }), children));
});
export { Carousel };